// import ClickAwayListener from "@material-ui/core/ClickAwayListener";
// import IconButton from "@material-ui/core/IconButton";
// import Visibility from "@material-ui/icons/Visibility";
// import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
// import Grow from "@material-ui/core/Grow";
// import MenuItem from "@material-ui/core/MenuItem";
// import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
//import Popper from "@material-ui/core/Popper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
//import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import get from "lodash/get";
//import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
//import DynamicForm from "Component/DynamicForm";
import parentdepartmentIcon from "Assets/newicons/app/profile/outline/parent-department.svg";
import emailIcon from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
// import DrawerHeader from "Component/Headers/drawerHeader";
// import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import defaultEmp from "../../../../../Assets/Images/defaultEmp.svg";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import {
  instance,
  instanceMultipart,
} from "../../../../../Actions/AxiosInstance";
import { refreshProfileInfo } from "../../../../../Actions/commonAction";
import loader from "../../../../../Assets/Gif/loader.gif";
import department from "../../../../../Assets/Icons/Department/department-16px.svg";
import designation from "../../../../../Assets/Icons/Designation/designation-16px.svg";
import empId from "../../../../../Assets/Icons/EmployeeId/emp-id-16px.svg";
import phone from "../../../../../Assets/Icons/Phone/phone-16px.svg";
import team from "../../../../../Assets/Icons/Team/team-16px.svg";
import If from "../../../../../Component/Common/If";
import createstore from "../../../../../store";
import { getFormattedImageLink, getFormattedDate } from "../../../../../Utils";
import { RightDrawer } from "../../../../../Actions/commonAction";
// import Divider from "@material-ui/core/Divider";
// import Resignation from "./Resignation";
// import defaultEmp from "../../../../../Assets/Images/defaultEmp.svg";
// import { FEATUREKEYS } from "../../../../../Constants/Featurekeys";
// import { AvatarPicker } from "./AvatarPicker";

// const styles = (theme) => ({

//   root: {
//     flexGrow: 1,
//   },
// });

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    height: 56,
  },
  leadloginbutton: {
    width: 200,
    height: 56,
  },
  dense: {},
  padding30: {
    padding: 30,
  },
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

function LabelValue({ label, value }) {
  return (
    <div className="margin-bottom-8">
      <p className="t-14 normal-dark-secondary floatleft">{label}</p>
      <p className="t-14 normal-dark-secondary floatright t-bold margin-right-4">
        {value}
      </p>
      <div className="clear-float"></div>
    </div>
  );
}

class EmpProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountid: "",
      subscriptionid: "",
      showPassword: false,
      countrytimezoneid: "",
      employeeid: "",
      ProfileBasicInfo: {},
      Appreciation: {},
      ProfileImg: "",
      colleagueid: null,
      apprcount: 0,
      AppreciationList: {},
      openOptions: false,
      openDrawer: false,
      exitpolicyid: null,
      showResign: false,
      allowselfresign: false,
      reactivateDrawer: false,
      resetPasswordDrawer: false,
      reActivateEmployeeData: [],
      newpassword: null,
      isnotify: false,
      ManagerList: [],
      EmpList: [],
      DepList: [],
      offset: 0,
      limit: 10,
      managerlimit: 3,
      // Emplist: [],
      OpenFlag: false,
      fullcount: "",
      managerfullcount: "",
    };
    this.openOptions = this.openOptions.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    // this.reActivateEmployeeData = this.reActivateEmployeeData.bind(this);
    // this.onReActivate = this.onReActivate.bind(this);
    // this.onResetPassword = this.onResetPassword.bind(this);
    // this.initiateResignation = this.initiateResignation.bind(this);
    // this.resetPassword = this.resetPassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    // let AuthenticationAction = createstore.getState().AuthenticationAction;
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;

    let employeeid;
    let masterprofileid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
      masterprofileid = AuthenticationAction.login.masterprofileid;
    }
    const { colleagueid } = this.props.match.params;
    const isoutsideapp = this.props.match.path.indexOf("newemployee") !== -1;

    const { permissions } = this.props;
    let hideButton;
    isoutsideapp
      ? (hideButton = false)
      : permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        isoutsideapp,
        showResign:
          AuthenticationAction.login && AuthenticationAction.login.isowner
            ? colleagueid &&
              colleagueid != AuthenticationAction.login.employeeid
              ? true
              : false
            : !isoutsideapp,
      },
      () => {
        this.GetProfileBasicInfo();
        this.GetSocialMediaLinks();
        this.GetManagerList();
        this.GetDepList();
        
        !isoutsideapp &&
          AuthenticationAction.login &&
          (!AuthenticationAction.login.isowner ||
            (AuthenticationAction.login.isowner &&
              colleagueid &&
              colleagueid != AuthenticationAction.login.employeeid)) 
              //&&
          //this.getResignationOn();
        // if (colleagueid && colleagueid != employeeid) {
        //   this.GetEmployeeDetails(colleagueid);
        // }
      },
    );
  }

  componentWillReceiveProps(props) {
    if (props.refreshProfileInfoReducer.doRefresh) {
      this.GetProfileBasicInfo();
    }
    let employeeid;
    let masterprofileid;
    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
      masterprofileid = AuthenticationAction.login.masterprofileid;
    } else {
      const { SubscriptionInfo } = createstore.getState();
      employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    }
    const { permissions } = this.props;
    const { colleagueid } = this.props.match.params;
    const isoutsideapp = this.props.match.path.indexOf("newemployee") !== -1;
    let hideButton;
    isoutsideapp
      ? (hideButton = false)
      : permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState({ hideButton });
    if (
      this.state.colleagueid === null ||
      this.state.colleagueid != props.match.params.colleagueid
    ) {
      this.setState({ colleagueid }, () => {
        if (colleagueid != employeeid) {
          this.GetProfileBasicInfo();
          this.GetSocialMediaLinks();
        }
      });
    }
  }

  // handleClickShowPassword = () => {
  //   this.setState((state) => ({ showPassword: !state.showPassword }));
  // };

  // OnFieldChange() {
  //   console.log("hello");
  // }

  // passwordKeyPress() {
  //   console.log("testing done");
  // }

  handleChange(value, key) {
    if (key == "newpassword") {
      this.setState({
        [key]: value.target.value,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
    console.log("testing done");
  }

  // getResignationOn() {
  //   instance
  //     .get(
  //       `exit/isexitactionallowed/${
  //         this.state.colleagueid
  //           ? this.state.colleagueid
  //           : this.state.employeeid
  //       }`,
  //     )
  //     .then((result) => {
  //       this.setState({
  //         showResign:
  //           (result.data.result[0] && result.data.result[0].isallowed) || false,
  //         exitpolicyid:
  //           (result.data.result[0] && result.data.result[0].exitpolicyid) ||
  //           null,
  //       });
  //     });
  // }

  GetEmployeeDetails = (colleagueid) => {
    instance.get(`subscription/getempolyeemanager/${colleagueid}/1/0/1`).then((result) => {
      if (
        get(result, "data.result[0].employeeid", "")
        == get(this.props, "AuthenticationAction.login.employeeid", "")
      ) {
        this.setState({ showResign: true });
      }
    });

    const data = {
      featurekey: "initiateResignation",
      workflowfortypeid: 4,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        if (get(result, "data.result", "").findIndex((x) => x.displayvalue == colleagueid) != -1) {
          this.setState({ showResign: true });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  toggleDrawer(value) {
    this.setState({ openDrawer: value });
  }

  getappreaciationCount() {
    let apprcount = 0;
    this.state.AppreciationList.map((cnt) => (apprcount += cnt.count));
    this.setState({ apprcount });
  }

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo = result.data.result[0])
          : (ProfileBasicInfo = []);
        const ProfileImg =
          ProfileBasicInfo.imagepath &&
          `${ProfileBasicInfo.imagepath}?${Date.now()}`;
        this.setState({ ProfileBasicInfo, ProfileImg });
        this.props.refreshProfileInfo(false);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateAppreciation() {
    if (this.state.employeeid != this.state.colleagueid) {
      const data = {
        employeeid: this.state.colleagueid,
      };
      const URL = "employee/insertempappreciation";
      instance
        .post(URL, data)
        .then(() => {
          let count = this.state.Appreciation.count
            ? this.state.Appreciation.count
            : 0;
          count += 1;
          const Appreciation = {};
          Appreciation.count = count;
          this.setState({ Appreciation, apprcount: count });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  // onReActivate() {
  //   this.props.enqueueSnackbar(
  //     "Are you sure you want to reactivate this employee?",
  //     {
  //       variant: "warning",
  //       action: [
  //         <Button
  //           key="key"
  //           color="inherit"
  //           size="small"
  //           onClick={() => {
  //             const data = {
  //               employeeid: this.state.colleagueid
  //                 ? this.state.colleagueid
  //                 : this.state.employeeid,
  //             };
  //             this.props.closeSnackbar();
  //             instance
  //               .post("employee/reactivateemployee", data)
  //               .then((result) => {
  //                 this.setState({
  //                   reactivateDrawer: false,
  //                   reActivateEmployeeData: [],
  //                 });
  //                 this.props.enqueueSnackbar("Reactivated successfully", {
  //                   variant: "success",
  //                 });
  //                 this.GetProfileBasicInfo();
  //               })
  //               .catch((error) => {
  //                 const msg =
  //                   error.response &&
  //                   error.response.data &&
  //                   error.response.data.error.message;
  //                 this.props.enqueueSnackbar(msg || "", {
  //                   variant: "error",
  //                 });
  //                 // this.setState({

  //                 //   createmenu: false,
  //                 // });
  //               });
  //           }}
  //         >
  //           Yes
  //         </Button>,
  //         <Button
  //           key="key"
  //           color="inherit"
  //           size="small"
  //           onClick={() =>
  //             this.setState({ createmenu: false }, () =>
  //               this.props.closeSnackbar(),
  //             )
  //           }
  //         >
  //           No
  //         </Button>,
  //       ],
  //     },
  //   );
  // }

  // onResetPassword() {
  //   const data = {
  //     employeeid: this.state.colleagueid
  //       ? this.state.colleagueid
  //       : this.state.employeeid,
  //     newpassword: this.state.newpassword,
  //     isnotify: this.state.isnotify,
  //   };
  //   instance
  //     .post("account/updateuserpassword", data)
  //     .then((result) => {
  //       this.setState({
  //         resetPasswordDrawer: false,
  //         newpassword: null,
  //         isnotify: false,
  //         showPassword: false,
  //       });
  //       this.props.enqueueSnackbar("successfully updated", {
  //         variant: "success",
  //       });
  //     })
  //     .catch((error) => {
  //       const msg =
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.error.message;
  //       this.props.enqueueSnackbar(msg || "", {
  //         variant: "error",
  //       });
  //     });
  // }

  OpenEmpList() {
    this.props.OpenEmpList();
  }

  GetSocialMediaLinks() {
    const URL = "employee/getempallcontact";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        const socialmediaLinks = result.data.result;
        let facebook;
        let twitter;
        let mail;
        let mobile;
        for (const obj of socialmediaLinks) {
          if (obj.contacttypeid == 8) {
            facebook = obj.contacttypevalue;
          }
          if (obj.contacttypeid == 9) {
            twitter = obj.contacttypevalue;
          }
          if (obj.contacttypeid == 1) {
            mail = obj.contacttypevalue;
          }
          if (obj.contacttypeid == 2) {
            mobile = obj.contacttypevalue;
          }
        }
        if (facebook) {
          const x = facebook.search("http");
          facebook = x == -1 ? `https://${facebook}` : null;
        }
        if (twitter) {
          const y = twitter.search("http");
          twitter = y == -1 ? `https://${twitter}` : null;
        }
        if (mail) {
          const z = mail.search("http");
          mail = z == -1 ? `https://${mail}` : null;
        }

        const facebookUrl = facebook;
        const twitterUrl = twitter;
        const mailUrl = mail;
        this.setState({
          facebookUrl,
          twitterUrl,
          mailUrl,
          facebook,
          twitter,
          mail,
          mobile,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  profileUpload(e) {
    const file = e.target.files[0];
    let extFile;
    if (file) {
      const img = file.name.split(";");
      const imgname = img[0];
      const idxDot = imgname.lastIndexOf(".") + 1;
      extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    }

    if (file && file.size > 2097152) {
      this.props.enqueueSnackbar(
        "Please Upload Valid Size Image (Maxsize : 2MB)",
        {
          variant: "error",
        },
      );
    } else if (
      !(
        extFile == "png" ||
        extFile == "jpg" ||
        extFile == "jpeg" ||
        extFile == "svg+xml"
      )
    ) {
      this.props.enqueueSnackbar("Please Upload valid image", {
        variant: "error",
      });
    } else {
      // let URL = '/upload/profile';
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          // file: e.target.files[0],
          ProfileImg: reader.result,
        });
      };
      reader.readAsDataURL(file);
      let employeeid;
      if (createstore.getState().AuthenticationAction.IsFulfilled) {
        const { AuthenticationAction } = createstore.getState();
        employeeid = AuthenticationAction.login.employeeid;
      } else {
        employeeid = this.state.employeeid;
      }
      const { colleagueid } = this.props;
      const URL = `/employee/profile/${this.props.SubscriptionData.accountid}/${
        this.props.SubscriptionData.subscriptionid
      }/${colleagueid || employeeid}/${
        this.props.SubscriptionData.countrytimezoneid
      }`;

      const formData = new FormData();
      if (createstore.getState().AuthenticationAction.IsFulfilled) {
        formData.append("file", file);
      } else {
        formData.append("file", file);
        formData.append("employeeid", this.state.employeeid);
        formData.append("accountid", this.state.accountid);
        formData.append("subscriptionid", this.state.subscriptionid);
        formData.append("timezoneid", this.state.countrytimezoneid);
      }
      // formData.append('employeeid', 16)
      this.setState({ ProfileImg: loader });

      instanceMultipart
        .post(URL, formData)
        .then((result) => {
          if (result.data.result) {
            const imgObj = result.data.result[0].imagesArray.find(
              (x) => x.imagetype == 4,
            );
            this.setState({ ProfileImg: `${imgObj.imagepath}?${Date.now()}` });
            this.props.enqueueSnackbar("Saved successfully", {
              variant: "success",
            });
          }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  // initiateResignation() {
  //   if (this.state.ProfileBasicInfo.stageid == 5) {
  //     this.props.enqueueSnackbar("Your notice period has already begun.", {
  //       variant: "error",
  //     });
  //   } else if (
  //     this.state.ProfileBasicInfo.stageid == 6 ||
  //     this.state.ProfileBasicInfo.stageid == 7
  //   ) {
  //     this.props.enqueueSnackbar("Employee is already inactive", {
  //       variant: "error",
  //     });
  //   } else {
  //     this.toggleDrawer(true);
  //   }
  // }

  // reActivateEmployeeData() {
  //   // const { employeeid } = this.state;
  //   instance
  //     .get(
  //       `employee/getreactivateemployeedetail/${
  //         this.state.colleagueid
  //           ? this.state.colleagueid
  //           : this.state.employeeid
  //       }`,
  //     )
  //     .then((result) => {
  //       this.setState({
  //         reActivateEmployeeData: result.data.result[0],
  //         reactivateDrawer: true,
  //       });
  //     })
  //     .catch((error) => {
  //       this.props.enqueueSnackbar(
  //         error.response ? error.response.data.error.message : error.message,
  //         { variant: "error" },
  //       );
  //     });
  // }

  // resetPassword() {
  //   this.setState({
  //     // reActivateEmployeeData: result.data.result[0],
  //     resetPasswordDrawer: true,
  //   });
  // }

  openOptions(value) {
    this.setState({ openOptions: value });
  }

  GetManagerList() {
    const id = this.state.colleagueid
      ? this.state.colleagueid
      : this.state.employeeid;
    instance
      .get(
        `/subscription/getempolyeemanager/${id}/${3}/${this.state.offset}/${
          this.state.managerlimit
        }`,
      )
      .then((result) => {
        let ManagerList = [];
        result.data.result.length > 0
          ? (ManagerList = result.data.result)
          : (ManagerList = []);
        const managerfullcount =
          result.data.result.length > 0 ? result.data.result[0].totalcount : 0;
        this.setState({ ManagerList, managerfullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetDepList() {
    const URL = "/employee/getempteamemployee";
    const data = {
      limit: 3,
      offset: 0,
      isteamemployee: false,
    };
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        // data = {
        //     "employeeid": this.state.colleagueid
        // }
        data.employeeid = this.state.colleagueid;
      } else {
        // data = {}
      }
    } else {
      // data = {
      //     "accountid": this.state.accountid,
      //     "subscriptionid": this.state.subscriptionid,
      //     "timezoneid": this.state.countrytimezoneid,
      //     "employeeid": this.state.employeeid,

      // }
      // Object.assign(data, {
      data.accountid = this.state.accountid;
      data.subscriptionid = this.state.subscriptionid;
      data.timezoneid = this.state.countrytimezoneid;
      data.employeeid = this.state.employeeid;
      // });
    }
    console.log("data: ", data);
    instance
      .post(URL, data)
      .then((result) => {
        let EmpList = [];
        result.data.result.length > 0
          ? (EmpList = result.data.result)
          : (EmpList = []);
        const fullcount =
          result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
        this.setState({ DepList: EmpList, fullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  HelperSliderFlag(flag, text) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    if (text == "Profilemanager") {
      this.props.RightDrawer({
        drawerdata: text,
        open: "right",
        side: flag,
        empid: this.state.employeeid,
      });
    } else {
      this.props.RightDrawer({ drawerdata: text, open: "right", side: flag });
    }
  }

  SetColleagueInfo(colleagueInfo, e) {

  }

  getCount = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  getCountManager = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  render() {
    const { classes } = this.props;
    const {
      ProfileBasicInfo,
      openOptions,
      openDrawer,
      showResign,
      exitpolicyid,
      hideButton,
    } = this.state;

    const {
      firstname = "",
      middlename = "",
      lastname = "",
      designationname,
      departmentname,
      teamname = "",
      parentdepartmentname = "",
      email,
      primarymobile,
      employeecode,
    } = ProfileBasicInfo;
    const fullname = `${firstname || ""} ${middlename || ""} ${lastname || ""}`;
    // const checkresigallow = get(this.props, "AuthenticationAction.login.features", []).find((feature) => feature.featureid == FEATUREKEYS.initiateResignation);
    const empcode = employeecode ? employeecode : "-";
    const isProfileEditAllowed =
      !get(this.props, "colleagueid", "") ||
      get(this.props, "AuthenticationAction.login.masterprofileid", "") >= 9;

    // const showResign = !this.props.history.location.pathname.includes("completeprofile") && isProfileEditAllowed && checkresigallow;
    return (
      <Paper className="padding20">
        <Grid container className="display-flex">
          
          <Grid
            item
            xs={12}
            md={2}
            sm={12}
            className="profile-img position-rel"
            align="center"
          >
            <img src={getFormattedImageLink(`${this.state.ProfileImg}`)} />
            <If condition={!hideButton}>
              <span className="onhoverbtn">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => this.profileUpload(e)}
                />
                <svg viewBox="0 0 24 24" style={{ width: 20 }}>
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                </svg>
              </span>
            </If>
          </Grid>
         
          
          <If condition={firstname}>
         
            <Grid item xs={12} md={7} sm={12} className="emp-name-1">
              <div
                className="display-flex margin-bottom-16"
                style={{ alignItems: "center" }}
              >
                <span>{`${fullname}`}</span>
                <span
                  className=""
                  style={{
                    marginLeft: 16,
                    fontSize: 12,
                    padding: "2px 16px",
                    borderRadius: 20,
                    border:
                      this.state.ProfileBasicInfo.stageid == 6 ||
                      this.state.ProfileBasicInfo.stageid == 7
                        ? "solid 1px #ddd"
                        : "solid 1px #008985",
                    background:
                      this.state.ProfileBasicInfo.stageid == 6 ||
                      this.state.ProfileBasicInfo.stageid == 7
                        ? "#f7f7f8"
                        : "#dcf2f1",
                    color:
                      this.state.ProfileBasicInfo.stageid == 6 ||
                      this.state.ProfileBasicInfo.stageid == 7
                        ? "#888"
                        : "#008985",
                    height: 16,
                  }}
                >
                  {this.state.ProfileBasicInfo.stageid == 6 ||
                  this.state.ProfileBasicInfo.stageid == 7
                    ? "Ex-employee"
                    : this.state.ProfileBasicInfo.stageid == 8
                    ? "Prospective employee"
                    : "Current employee"}
                </span>
              </div>
              {designationname && (
                <Tooltip title="Designation" placement="top">
                  <div
                    style={{
                      fontSize: 13,
                      float: "left",
                      marginBottom: 12,
                      marginRight: 16,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={designation}></img>
                    </span>
                    <span className="floatleft">{designationname}</span>
                  </div>
                </Tooltip>
              )}

              {employeecode && (
                <Tooltip title="Employee code" placement="top">
                  <div
                    style={{
                      fontSize: 13,
                      float: "left",
                      marginBottom: 12,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={empId} height="16"></img>
                    </span>
                    <span className="floatleft">{employeecode}</span>
                  </div>
                </Tooltip>
              )}
              <div className="clear-float"></div>

              {primarymobile && (
                <Tooltip title="Mobile number" placement="top">
                  <div
                    style={{
                      float: "left",
                      fontSize: 13,
                      marginRight: 16,
                      marginBottom: 12,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={phone}></img>
                    </span>
                    <span className="floatleft">{primarymobile}</span>
                  </div>
                </Tooltip>
              )}

              {email && (
                <Tooltip title="Email id" placement="top">
                  <div
                    style={{
                      float: "left",
                      fontSize: 13,
                      marginBottom: 12,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={emailIcon}></img>
                    </span>
                    <span className="floatleft">{email}</span>
                  </div>
                </Tooltip>
              )}

              <div style={{ clear: "both" }} />

              {parentdepartmentname && (
                <Tooltip title="Parent department" placement="top">
                  <div
                    style={{
                      fontSize: 13,
                      float: "left",
                      marginRight: 16,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={parentdepartmentIcon}></img>
                    </span>
                    <span className="floatleft">{parentdepartmentname}</span>
                  </div>
                </Tooltip>
              )}

              {departmentname && (
                <Tooltip title="Department" placement="top">
                  <div
                    style={{
                      fontSize: 13,
                      float: "left",
                      marginRight: 16,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={department}></img>
                    </span>
                    <span className="floatleft">{departmentname}</span>
                  </div>
                </Tooltip>
              )}

              {teamname && (
                <Tooltip title="Team" placement="top">
                  <div
                    style={{
                      fontSize: 13,
                      float: "left",
                      marginRight: 16,
                    }}
                  >
                    <span className="floatleft margin-right-8">
                      <img src={team}></img>
                    </span>
                    <span className="floatleft">{teamname}</span>
                  </div>
                </Tooltip>
              )}
            </Grid>
         
          </If>
          <Grid item xs={12} md={3} sm={12}>
          <table class="table" style={{marginTop: -5}}>
              <tr>
              <td>
                <tr><td>
              {/* <Grid item xs={12} md={12} sm={12}> */}
                  {/* <div className="width100" style={{ height:30 , marginBottom:20,marginTop:-18}}> */}
                    <FormattedMessage id="LbManager" defaultMessage="Manager" />
                </td></tr>
                <tr> <td>
                    {this.state.ManagerList.length > 0 ? (
                      <div style={{ paddingTop: 3, paddingBottom:15 }}>
                        <div className="avtar-thumb-wrapper" style={{ height:38}}>
                          {this.state.ManagerList.map((mgr) => (
                            <div
                              className={
                                this.getCountManager(this.state.managerfullcount) > 0
                                  ? "avtar-thumb-blur"
                                  : "avtar-thumb"
                              }
                              key="key"
                            >
                              {this.state.colleagueid ? (
                                <Link to={`./${mgr.employeeid}`} target="_blank">
                                  <Tooltip
                                    key="key"
                                    title={mgr.employeename}
                                    placement="bottom"
                                  >
                                    <div className="avatar-wrapper">
                                      {mgr.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(mgr.imagepath)}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      )}
                                    </div>
                                  </Tooltip>
                                </Link>
                              ) : (
                                <Tooltip
                                  key="key"
                                  title={mgr.employeename}
                                  placement="bottom"
                                >
                                  <Link
                                    to={`./profile/${mgr.employeeid}`}
                                    target="_blank"
                                  >
                                    <div className="avatar-wrapper">
                                      {mgr.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(mgr.imagepath)}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </Tooltip>
                              )}
                            </div>
                          ))}
                        </div>
                        {this.getCountManager(this.state.managerfullcount) > 0 ? (
                          <span
                            className={classNames("managercount", "cursour-pointer")}
                            style={{height:30}}
                            onClick={this.HelperSliderFlag.bind(
                              this,
                              true,
                              "Profilemanager",
                            )}
                          >
                            <span>
                              <div className="total-count total-count-small" style={{height:30, width:30, fontSize:11 ,top:3}} >
                                +{this.getCountManager(this.state.managerfullcount)}
                              </div>
                            </span>
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div style={{ paddingTop: 3, paddingBottom:10}}>
                        <span className="small-dark-secondary t-14" >💃 Yay! you are your own boss</span>
                      </div>
                    )}
                  {/* </div> */}
              {/* </Grid> */}
                </td></tr>
              </td>
              </tr>
              
              <tr>
              <td>
              <tr><td>
              {/* <Grid item xs={12} md={12} sm={12}> */}
                  {/* <div className="width100" style={{ height: 30, width: 206 , marginTop:10}} > */}
                    <FormattedMessage id="LbDepartment" defaultMessage="Department" />
                    </td></tr>
                <tr> <td>
                    {this.state.DepList.length > 0 ? (
                      <div style={{ paddingTop: 3, paddingBottom:15 }}>
                        <div className="avtar-thumb-wrapper" >
                          {this.state.DepList.map((emp) => (
                            <div
                              className={
                                this.getCount(this.state.fullcount) > 0
                                  ? "avtar-thumb-blur"
                                  : "avtar-thumb"
                              }
                              key="key"
                            >
                              {this.state.colleagueid ? (
                                <Link to={`./${emp.employeeid}`} target="_blank">
                                  <Tooltip
                                    title={emp.employeename}
                                    placement="bottom"
                                  >
                                    <div
                                      className="avatar-wrapper"
                                      onClick={this.SetColleagueInfo.bind(this, emp)}
                                    >
                                      {emp.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(emp.imagepath)}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      )}
                                    </div>
                                  </Tooltip>
                                </Link>
                              ) : (
                                <Tooltip title={emp.employeename} placement="bottom">
                                  <Link
                                    to={`./profile/${emp.employeeid}`}
                                    target="_blank"
                                  >
                                    <div
                                      className="avatar-wrapper"
                                      onClick={this.SetColleagueInfo.bind(this, emp)}
                                    >
                                      {emp.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(emp.imagepath)}
                                          height="30"
                                          className="team-avatar"
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </Tooltip>
                              )}
                            </div>
                          ))}
                        </div>
                        {this.getCount(this.state.fullcount) > 0 ? (
                          <span
                            // className={classNames("teamdrawer drawer1")}
                            className={classNames("managercount", "cursour-pointer")}
                            style={{height:30, width:30}}
                            onClick={this.HelperSliderFlag.bind(
                              this,
                              true,
                              "Profileteam",
                            )}
                          >
                            <span>
                              <div className="total-count total-count-small" style={{height:30, width:30, fontSize:11,top:3}}>
                                +{this.getCount(this.state.fullcount)}
                              </div>
                            </span>
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div style={{ paddingTop: 3 }}>
                        <span className="small-dark-secondary t-14">
                          💁‍♂️ You run the department single-handedly
                        </span>
                      </div>
                    )}
                  {/* </div> */}
              {/* </Grid> */}
              </td></tr>
              </td>
              </tr>
         </table>
          </Grid>

          {/* {((this.props.AuthenticationAction &&
            this.props.AuthenticationAction.login &&
            this.props.AuthenticationAction.login.masterprofileid == 9) ||
            showResign ||
            ((ProfileBasicInfo.stageid == 6 || ProfileBasicInfo.stageid == 7) &&
              this.props.AuthenticationAction &&
              this.props.AuthenticationAction.login &&
              this.props.AuthenticationAction.login.masterprofileid == 9) ||
            (this.props.AuthenticationAction &&
              this.props.AuthenticationAction.login &&
              this.props.AuthenticationAction.login.masterprofileid == 9 &&
              ProfileBasicInfo.isselfservice == true)) && (
            <Grid item xs={12} md={1} sm={2}>
              <div
                onClick={() => this.openOptions(true)}
                className="profile-more-options-icon"
              >
                <i className="material-icons floatleft">more_vert</i>
                <Popper
                  open={openOptions}
                  anchorEl={this.anchorEl}
                  transition
                  disablePortal
                  className="profile-more-options"
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom" ? "right top" : "right bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener
                          onClickAway={() => this.openOptions(false)}
                        >
                          <MenuList>
                            {(showResign ||
                              (exitpolicyid != null &&
                                this.props.AuthenticationAction &&
                                this.props.AuthenticationAction.login
                                  .masterprofileid == 9)) && (
                              <MenuItem
                                onClick={() => this.initiateResignation()}
                              >
                                Initiate Resignation
                              </MenuItem>
                            )}
                            {this.props.AuthenticationAction.login
                              .masterprofileid == 9 &&
                              (ProfileBasicInfo.stageid == 6 ||
                                ProfileBasicInfo.stageid == 7) && (
                                <MenuItem
                                  onClick={() => this.reActivateEmployeeData()}
                                >
                                  Re-activate employee
                                </MenuItem>
                              )}
                            {this.props.AuthenticationAction.login
                              .masterprofileid == 9 &&
                              ProfileBasicInfo.isselfservice == true &&
                              this.state.colleagueid &&
                              this.state.colleagueid !=
                                this.state.employeeid && (
                                <MenuItem onClick={() => this.resetPassword()}>
                                  Set password
                                </MenuItem>
                              )}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </Grid>
          )} */}
        </Grid>
        
       
        
      </Paper>
    );
  }
}

EmpProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      RightDrawer: (data) => RightDrawer(data),
      refreshProfileInfo: (data) => refreshProfileInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpProfile)));
